import store from '../../../core/store';

export const listCompanyHolidays = () => {
  return store.dispatch({
    action: 'table.company_holidays/LIST_COMPANY_HOLIDAYS',
    method: 'GET',
    endpoint: '/company_holidays',
    main: true,
  });
};

export const createCompanyHoliday = (formData) => {
  return store.dispatch({
    action: 'table.company_holidays/CREATE_COMPANY_HOLIDAYS',
    method: 'POST',
    endpoint: '/company_holidays',
    data: formData,
  });
};

export const readCompanyHoliday = (company_holiday_id) => {
  return store.dispatch({
    action: 'table.company_holidays/READ_COMPANY_HOLIDAY',
    method: 'GET',
    endpoint: '/company_holidays/' + company_holiday_id,
  });
};

export const updateCompanyHoliday = (company_holiday_id, formData) => {
  return store.dispatch({
    action: 'table.company_holidays/UPDATE_COMPANY_HOLIDAY',
    method: 'PUT',
    endpoint: '/company_holidays/' + company_holiday_id,
    data: formData,
  });
};

export const deleteCompanyHoliday = (id) => {
  return store.dispatch({
    action: 'table.company_holidays/DELETE_COMPANY_HOLIDAYS',
    method: 'DELETE',
    endpoint: '/company_holidays/' + id,
  });
};

export const readCompanyHolidaysPeriod = ({ date_from, date_to }) => {
  const query = [`date_from=${encodeURIComponent(date_from)}`];

  if (date_to) {
    query.push(`date_to=${encodeURIComponent(date_to)}`);
  }

  return store.dispatch({
    action: 'table.company_holidays/READ_COMPANY_HOLIDAYS_PERIOD',
    method: 'GET',
    endpoint: `/company_holidays/period?${query.join('&')}`,
    preloaded: false,
  });
};
